import React from 'react'

import { createBrowserRouter } from 'react-router-dom'

import { ChangeEmailRoute } from './ChangeEmailRoute'
import { SentryReactTestRoute } from './SentryReactTestRoute'
import { SignInPartnerRoute } from './SignInPartnerRoute'
import { SignInRoute } from './SignInRoute'

export const router = createBrowserRouter([
  {
    path: '/signin',
    element: <SignInRoute />,
  },
  {
    path: '/signin_partner',
    element: <SignInPartnerRoute />,
  },
  {
    path: '/change_email',
    element: <ChangeEmailRoute />,
  },
  {
    path: '/admin/debug/sentry_react_test',
    element: <SentryReactTestRoute />,
  },
])
